import HeroVideoDialog from '@/shared/ui/hero-video-dialog.tsx';

const ContentSection = () => {
  return (
    <div className="relative font-poppins tracking-wide container mx-auto space-y-10 py-10 px-7">
      <h2 className='text-xl lg:text-3xl w-full text-center tracking-wide'>Testimonials</h2>
      <div className='w-full flex flex-col lg:flex-row gap-5'>
        <div className='w-full lg:w-1/2'>
          <HeroVideoDialog
            className="block dark:hidden"
            animationStyle="from-center"
            videoSrc="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9nfO2v1jFXeoEuz1R0LN8a2SkPDg9MshcvKfx"
            thumbnailSrc='https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9C5Q4mPdZeKrO16wj9s3S0dhQR2tA58Z4FipT'
          />
        </div>

        <div className='w-full lg:w-1/2 flex flex-col justify-end gap-4'>
          <p className='text-xl font-semibold font-montserrat italic tracking-wide'>
            "You captured my vision for Amy MD exactly, the graphics, the captions, everything. It was phenomenal. I just wish we had met sooner!”
          </p>
          <p className='w-full text-end font-poppins tracking-wide'> ~ AskmeyourMD</p>
        </div>
      </div>
      <h2 className='text-xl lg:text-3xl w-full text-center tracking-wide pt-5 lg:pt-20'>Podcasts</h2>
      <div className='w-full flex flex-col lg:flex-row gap-5'>
        <div className='w-full lg:w-1/2'>
          <HeroVideoDialog
            className="block dark:hidden"
            animationStyle="from-center"
            videoSrc="https://www.youtube.com/embed/CcllC1zUSGs?si=RTMQxWhHX_HngJsG"
            thumbnailSrc='https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9YBoGVF1NMFK6AZWV9Qv1IGE4zy5CdbBeqfDP'
          />
        </div>

        <div className='w-full lg:w-1/2 flex flex-col justify-end gap-4'>
          <p className='font-semibold text-xl font-montserrat italic tracking-wide'>
            Exploring the Role of Artificial IntelligenceA Conversation with Vik Sharma founder of SiAi
          </p>
          <p className='w-full text-end font-poppins tracking-wide'> ~ Querlo Team</p>
        </div>
      </div>
    </div>
  )
}

export default ContentSection;
